import httpClient from './http-clients';

export const fetchBanners = async () => {
  const response = await httpClient.get('/banners');
  return response.data;
};
